module.exports = __webpack_public_path__ + "img/department.c359f6ac.svg";